// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"170":"bfeddb0949f1554d","364":"569e3909e98490bd","440":"0caa4bb045b6ef54","581":"fb860b63890aad81","681":"84985bb9acaaaaee"}[chunkId] + ".js";
};